import { render, staticRenderFns } from "./ReporteCotizaciones.vue?vue&type=template&id=6b767eaf"
import script from "./ReporteCotizaciones.vue?vue&type=script&lang=js"
export * from "./ReporteCotizaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports